import { render } from "./index_ai.vue?vue&type=template&id=0fa1e989"
import script from "./index_ai.vue?vue&type=script&lang=js"
export * from "./index_ai.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__